import { create } from 'zustand';
import { message } from 'antd';
import axiosInstance from '../utils/axiosInstance';

const useMediaStore = create((set) => ({
  items: [],
  currentPath: '',
  loading: false,
  error: null,

  setCurrentPath: (path) => set({ currentPath: path }),

  fetchItems: async (path = '') => {
    set({ loading: true });
    try {
      const response = await axiosInstance.get(`/media/list/?path=${path}`);
      set({ 
        items: response.data.items,
        loading: false,
        error: null 
      });
      return response.data.items;
    } catch (error) {
      set({ error: error.message, loading: false });
      message.error('Failed to fetch items');
      return [];
    }
  },

  createFolder: async (name, path = '') => {
    try {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('path', path);

      await axiosInstance.post('/media/create-folder/', formData);
      message.success('Folder created successfully');
      return { success: true };
    } catch (error) {
      message.error('Failed to create folder');
      return { success: false, error };
    }
  },

  uploadFile: async (file) => {
    set({ loading: true });
    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await axiosInstance.post('/media/upload/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      set(state => ({
        items: [...state.items, file.name],
        loading: false,
        error: null
      }));
      message.success('File uploaded successfully');
      return { success: true, data: response.data };
    } catch (error) {
      set({ loading: false });
      message.error('Failed to upload file');
      return { success: false, error };
    }
  },

  deleteFile: async (filename) => {
    try {
      await axiosInstance.delete(`/media/delete/${filename}/`);
      set(state => ({
        items: state.items.filter(file => file !== filename),
      }));
      message.success('File deleted successfully');
      return { success: true };
    } catch (error) {
      message.error('Failed to delete file');
      return { success: false, error };
    }
  },

  renameFile: async (oldFilename, newFilename) => {
    try {
      await axiosInstance.put(`/media/rename/${oldFilename}/${newFilename}/`);
      set(state => ({
        items: state.items.map(file => 
          file === oldFilename ? newFilename : file
        ),
      }));
      message.success('File renamed successfully');
      return { success: true };
    } catch (error) {
      message.error('Failed to rename file');
      return { success: false, error };
    }
  },

  // Updated getFileUrl to include path
  getFileUrl: (filename) => {
    const state = useMediaStore.getState();
    const path = state.currentPath ? `${state.currentPath}/` : '';
    return `${process.env.PUBLIC_URL}/components/img/${path}${filename}`;
  }
}));

export default useMediaStore;
